import styled from 'styled-components';
import { fontSize, fontWeight, mediaMax, primaryColor } from '@styles/utils';
import FormField from '@shared/modules/form/components/FormField';
import { Button } from '@styles/shared/buttons';
import CustomLink from '@shared/components/link/CustomLink';

export const TicketSignInContainer = styled.div`
  padding: 40px 0;
  margin: 0 auto;
  width: 100%;
  max-width: 1090px;

  @media screen and (max-width: 1230px) {
    padding: 40px 16px;
  }

  @media screen and (${mediaMax.tablet}) {
    padding-top: 20px;
  }
`;

export const TicketSignInTitle = styled.h2`
  ${fontSize.h2};
  font-weight: ${fontWeight.standard};
  color: ${primaryColor(500)};
`;

export const TicketSignInFormContainer = styled.div`
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  max-width: 540px;
  width: 100%;
`;

export const TicketSignInFormContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TicketSignInFormInput = styled(FormField)`
  padding-bottom: 16px;
`;

export const TicketSignInFormButton = styled(Button)`
  margin: 32px 0 16px 0 !important;
  width: max-content;
`;

export const TicketSignInFormLink = styled(CustomLink)`
  font-weight: ${fontWeight.standard};
`;

export const TicketSignInFormDivider = styled.div`
  margin: 36px 0;
  opacity: 0.2;
  background-color: #707070;
  max-width: 540px;
  width: 100%;
  height: 1px;

  @media screen and (${mediaMax.tablet}) {
    max-width: 100%;
  }
`;

export const TicketSignInFormWithoutAccount = styled.p`
  padding-bottom: 15px;
  max-width: 540px;
  width: 100%;

  @media screen and (${mediaMax.tablet}) {
    max-width: 100%;
  }
`;
